export default __webpack_public_path__ + "static/media/Group 2121.807a4f77.png";